import angular from 'angular';
import appFooterComponent from './appFooter.component';

let appFooterModule = angular.module('appFooter', []).component('appFooter', appFooterComponent);

export default appFooterModule;



// WEBPACK FOOTER //
// ./app/common/appFooter/appFooter.js